import { navigateTo, useRuntimeConfig } from '#imports'
import type { RouteLocationNormalized, RouteRecordRaw } from 'vue-router'

import type { Market } from '@backmarket/http-api'

import { PAGE_NAME_BY_PLP_UUID } from '~/scopes/cms/service/content-service.config'
import { generateWebviewRoutes } from '~/scopes/webviews/generateWebviewRoutes'
import redirectIfWebview from '~/scopes/webviews/middleware/redirectIfWebview'

import { ROUTES as PRODUCT_LIST_ROUTES } from './route-names'

export default ({ market }: { market: Market }): RouteRecordRaw[] => {
  const {
    public: { FF_NEW_SELLER_PAGE },
  } = useRuntimeConfig()

  const availableUniverseUUID = PAGE_NAME_BY_PLP_UUID[market.countryCode]
  const universeRegex = availableUniverseUUID
    ? Object.keys(availableUniverseUUID).join('|')
    : '!?'

  const universeRoute: RouteRecordRaw = {
    name: PRODUCT_LIST_ROUTES.UNIVERSE,
    component: () => import('../cms/Landing.vue'),
    path: `l/:slugV2/:uuid(${universeRegex})`,
    meta: {
      owners: ['bot-squad-search-and-recommendation-front'],
      middleware: [redirectIfWebview],
      cache: 'public, max-age=90000',
    },
  }

  const sellerProductListRoute: RouteRecordRaw = {
    path: 's/:merchantName/:uuid',
    name: PRODUCT_LIST_ROUTES.SELLER_PRODUCT_LIST,
    meta: {
      owners: ['bot-squad-search-and-recommendation-front'],
      middleware: [redirectIfWebview],
      cache: 'public, max-age=300',
    },
    component: () =>
      FF_NEW_SELLER_PAGE
        ? import('./pages/SellerPage/SellerPage.vue')
        : import('./pages/SellerProductListPage/SellerProductListPage.vue'),
  }

  return [
    {
      path: 'search',
      name: PRODUCT_LIST_ROUTES.SEARCH_RESULTS,
      meta: {
        owners: ['bot-squad-search-and-recommendation-front'],
      },
      component: () => import('./pages/SearchResultPage/SearchResultPage.vue'),
    },
    {
      path: 'l/:slugV2/:uuid',
      name: PRODUCT_LIST_ROUTES.PRODUCT_LIST,
      meta: {
        owners: ['bot-squad-search-and-recommendation-front'],
        middleware: (to: RouteLocationNormalized) => {
          if (
            Array.isArray(to.params.uuid) || !availableUniverseUUID
              ? false
              : to.params.uuid in availableUniverseUUID
          ) {
            const universePage: RouteLocationNormalized = {
              ...to,
              name: PRODUCT_LIST_ROUTES.UNIVERSE,
            }

            return navigateTo(universePage)
          }

          return undefined
        },
        cache: 'public, max-age=90000',
      },
      component: () => import('./pages/ProductListPage/ProductListPage.vue'),
    },
    sellerProductListRoute,
    universeRoute,
    ...generateWebviewRoutes([sellerProductListRoute, universeRoute]),
  ]
}
